import { SubmitHandler } from "react-hook-form";
import { IForgottenPasswordFormModel } from "../models/forgottenPasswordFormModel";
import { useForgottenPasswordForm } from "./useForgottenPasswordForm";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { routePaths } from "../../../../common/infrastructure/routes/routePaths";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";

export const useForgottenPasswordPage = () => {
  const form = useForgottenPasswordForm();
  const navigate = useNavigate();

  const { mutate: mutate } = useApiMutation();

  const [isRequestSent, setIsRequestSent] = useState(false);

  const successMessage =
    "На посоченият имейл Ви изпратихме инструкции за възстановяване на паролата.";

  const navigateToLogin = () => {
    navigate(routePaths.login);
  };

  const sendRequest: SubmitHandler<IForgottenPasswordFormModel> = async (
    data
  ) => {
    mutate(
      {
        endpoint: endpointsMetadata.authentication.forgottenPassword,
        globalIsLoading: true,
        method: "post",
        ...data,
      },
      {
        onSuccess: () => {
          if (!isRequestSent) {
            setIsRequestSent(true);
          }
        },
      }
    );
  };

  return {
    form,
    successMessage,
    isRequestSent,
    sendRequest,
    navigateToLogin,
  };
};
